import SwaggerUI from "swagger-ui-react"
import "swagger-ui-react/swagger-ui.css"

export function ApiSpec() {
    return (
            <SwaggerUI url="https://api.boycottisraeli.biz/v1/documentation/openapi/yaml" />
    )
}